export type NeoStreamEvent =
  | { type: 'status'; message: string }
  | { type: 'tool_start'; tool: { name: string; label?: string } }
  | { type: 'tool_result'; tool: { name: string; label?: string }; result: { summary: string; data?: Record<string, unknown> } }
  | { type: 'text'; text: string }
  | { type: 'error'; message: string }
  | { type: 'done' };

function record(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : {};
}

function stringValue(value: unknown): string | undefined {
  return typeof value === 'string' ? value : undefined;
}

function normalizeParsedEvent(parsed: unknown): NeoStreamEvent {
  const payload = record(parsed);
  const type = stringValue(payload.type);
  if (type === 'status') return { type, message: stringValue(payload.message) ?? 'Working...' };
  if (type === 'tool_start') {
    const tool = record(payload.tool);
    return {
      type,
      tool: {
        name: stringValue(tool.name) ?? 'tool',
        label: stringValue(tool.label),
      },
    };
  }
  if (type === 'tool_result') {
    const tool = record(payload.tool);
    const result = record(payload.result);
    return {
      type,
      tool: {
        name: stringValue(tool.name) ?? 'tool',
        label: stringValue(tool.label),
      },
      result: {
        summary: stringValue(result.summary) ?? 'Completed.',
        data: record(result.data),
      },
    };
  }
  if (type === 'error') return { type, message: stringValue(payload.message) ?? 'Neo hit an error.' };
  if (type === 'done') return { type };
  const text = stringValue(payload.text) ?? stringValue(payload.chunk) ?? stringValue(payload.content);
  return { type: 'text', text: text ?? JSON.stringify(parsed) };
}

export function parseNeoStreamFrame(frame: string): NeoStreamEvent | null {
  const line = frame.split('\n').find((item) => item.trim().startsWith('data:'));
  if (!line) return null;
  const payload = line.slice(line.indexOf('data:') + 5).trim();
  if (!payload) return null;
  if (payload === '[DONE]') return { type: 'done' };
  try {
    return normalizeParsedEvent(JSON.parse(payload));
  } catch {
    return { type: 'text', text: payload };
  }
}
